// components/StepNavigation.js
import React from 'react';
import { useApp } from '../context/AppContext';

const StepNavigation = () => {
  const { state } = useApp();
  const { currentStep } = state;

  const steps = [
    { number: 1, title: 'Informações Básicas' },
    { number: 2, title: 'Logo & Splash' },
    { number: 3, title: 'Personalização' },
    { number: 4, title: 'Plataformas' },
    { number: 5, title: 'Menu & Ícones' },
    { number: 6, title: 'Revisão' }
  ];
  // comentei o último item da lista de passos
  return (
    <div className="mb-12 px-4">
      <div className="flex items-center w-full">
        {steps.map((step, index) => {
          const isCompleted = currentStep > step.number;
          const isActive = currentStep === step.number;
          const isPending = currentStep < step.number;
          const isLast = index === steps.length - 1;

          // Estado da linha conectora (se não for o último item)
          // A linha deve ser preenchida se o passo ATUAL já passou deste ponto
          // Ou seja, se estamos no passo 2, a linha 1-2 deve estar cheia.
          const isConnectorFull = currentStep > step.number;

          return (
            <React.Fragment key={step.number}>
              {/* Círculo do Passo */}
              <div className="flex flex-col items-center group cursor-default relative z-10">
                
                {/* Spinner Giratório Externo para o Passo Ativo */}
                {isActive && (
                  <div className="absolute -inset-2 rounded-full border-2 border-gray-900 border-t-transparent border-r-transparent animate-spin z-0"></div>
                )}

                <div className={`
                  relative flex items-center justify-center w-10 h-10 rounded-full transition-all duration-500 z-10
                  ${isActive ? 'scale-110 bg-white text-gray-900' : ''}
                  ${isCompleted ? 'bg-gray-900 text-white shadow-lg shadow-gray-300 scale-100' : ''}
                  ${isPending ? 'bg-white border-2 border-gray-200 text-gray-300 scale-90' : ''}
                  ${isActive ? 'shadow-xl' : ''}
                `}>
                  {/* Conteúdo do Círculo */}
                  {isCompleted ? (
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                    </svg>
                  ) : (
                    <span className={`font-bold text-sm ${isActive ? 'text-gray-900' : 'text-inherit'}`}>
                      {step.number}
                    </span>
                  )}
                </div>
                
                {/* Título do step */}
                <div className={`
                  absolute mt-14 text-center transition-all duration-500 hidden sm:block w-32
                  ${isActive ? 'opacity-100 -translate-y-1 transform' : 'opacity-60'}
                  ${isPending ? 'text-gray-300' : 'text-gray-900'}
                `}>
                  <p className={`text-xs font-bold uppercase tracking-wider ${isActive ? 'text-gray-900' : 'text-gray-400'}`}>
                    {step.title}
                  </p>
                </div>
              </div>

              {/* Linha Conectora (se não for o último) */}
              {!isLast && (
                <div className="flex-1 mx-2 h-0.5 relative bg-gray-200">
                  {/* Fundo Tracejado (sempre visível como base) */}
                  <div className="absolute inset-0 border-t-2 border-dashed border-gray-300"></div>
                  
                  {/* Preenchimento Sólido Animado */}
                  <div 
                    className={`
                      absolute inset-y-0 left-0 bg-gray-900 transition-all duration-700 ease-in-out shadow-[0_0_8px_rgba(0,0,0,0.1)]
                    `}
                    style={{ width: isConnectorFull ? '100%' : '0%' }}
                  >
                     {/* Brilho na ponta quando está preenchendo (opcional, pode ser removido se ficar muito poluído) */}
                     {/* <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1.5 h-1.5 bg-white rounded-full shadow-sm"></div> */}
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default StepNavigation;
